import React, { useState, useEffect } from "react";
// removed unused useNavigate
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Config from "../Header/Config";
import Footer from "../Header/Footer";
import Header from "../Header/Header";

export default function Model() {
  const [model, setModel] = useState("");
  const [color, setColor] = useState("");
  const [description, setDescription] = useState("");
  const [isDataChanged, setIsDataChanged] = useState(false);
  
  // Validation states
  const [errors, setErrors] = useState({
    model: "",
    color: "",
    description: "",
  });
  const [touched, setTouched] = useState({
    model: false,
    color: false,
    description: false,
  });
  const [submitAttempted, setSubmitAttempted] = useState(false);
  
  // navigation not used in this component

  const apiUrl = Config.apiUrl;

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  // Validation functions
  const validateModel = (value) => {
    if (!value || value.trim() === "") {
      return "Model name is required";
    }
    if (value.trim().length < 2) {
      return "Model name must be at least 2 characters";
    }
    if (value.trim().length > 50) {
      return "Model name must not exceed 50 characters";
    }
    // Allow alphanumeric, spaces, hyphens, and underscores
    if (!/^[a-zA-Z0-9\s\-_]+$/.test(value.trim())) {
      return "Model name can only contain letters, numbers, spaces, hyphens, and underscores";
    }
    return "";
  };

  const validateColor = (value) => {
    if (!value || value.trim() === "") {
      return "Color name is required";
    }
    if (value.trim().length < 2) {
      return "Color name must be at least 2 characters";
    }
    if (value.trim().length > 30) {
      return "Color name must not exceed 30 characters";
    }
    // Allow only letters and spaces
    if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
      return "Color name can only contain letters and spaces";
    }
    return "";
  };

  const validateDescription = (value) => {
    if (value && value.trim().length > 0) {
      if (value.trim().length < 5) {
        return "Description must be at least 5 characters if provided";
      }
      if (value.trim().length > 500) {
        return "Description must not exceed 500 characters";
      }
    }
    return "";
  };

  // Validate all fields
  const validateAll = () => {
    const newErrors = {
      model: validateModel(model),
      color: validateColor(color),
      description: validateDescription(description),
    };
    setErrors(newErrors);
    return !newErrors.model && !newErrors.color && !newErrors.description;
  };


  // ..............................< Unsaved Navigation>...............................
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDataChanged) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataChanged]);


  // Callback function to handle navigation from the header
  const handleHeaderNavigation = () => {
    if (isDataChanged && !window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
      // If there are unsaved changes and the user clicks cancel, prevent navigation
      return false;
    }
    return true; // Allow navigation
  };



  // ........................<Save Model Data>......................

  const addModel = async (e) => {
    e.preventDefault();

    // Mark submit as attempted
    setSubmitAttempted(true);

    // Mark all fields as touched
    setTouched({
      model: true,
      color: true,
      description: true,
    });

    // Validate all fields
    if (!validateAll()) {
      return;
    }

    // Reset submit attempted on successful validation
    setSubmitAttempted(false);

    let item = {
      model_name: model.trim().toUpperCase(),
      color_name: capitalizeWords(color.trim()),
      description: description.trim(),
    };

    try {
      const response = await fetch(`${apiUrl}/get_all_models`);
      const data = await response.json();

      const isModelExists = data.data.some(
        (row) => row.model_name === model.toUpperCase()
      );

      if (isModelExists) {
        toast.error('Model already exists', { autoClose: 1500 });
      } else {
        const result = await fetch(`${apiUrl}/save_model`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(item),
        });

        if (result.ok) {
          toast.success('Model added successfully', { autoClose: 1500 });
          setModel('');
          setColor('');
          setDescription('');
          setErrors({
            model: "",
            color: "",
            description: "",
          });
          setTouched({
            model: false,
            color: false,
            description: false,
          });
          setSubmitAttempted(false);
          setIsDataChanged(false);
          
          // Reload the page after successful submission
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          toast.error('Failed to add Model', { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.log(error);
      toast.warning('Error occurred', { autoClose: 1500 });
    }
  };


  // ...........................<Cancle Model>.......................

  const cancelModel = () => {
    if (isDataChanged) {
      const confirmCancel = window.confirm('You have unsaved changes. Are you sure you want to cancel?');
      if (!confirmCancel) {
        return;
      }
    }

    setModel('');
    setColor('');
    setDescription('');
    setErrors({
      model: "",
      color: "",
      description: "",
    });
    setTouched({
      model: false,
      color: false,
      description: false,
    });
    setSubmitAttempted(false);
    setIsDataChanged(false);

    // Use the navigate function to redirect to another page
    // replace '/your-redirect-path' with the desired path
  };

  const handleModelChange = (e) => {
    const value = e.target.value.toUpperCase();
    setModel(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.model || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        model: validateModel(value),
      }));
    }
  };

  const handleModelBlur = () => {
    setTouched((prev) => ({ ...prev, model: true }));
    setErrors((prev) => ({
      ...prev,
      model: validateModel(model),
    }));
  };

  const handleColorChange = (e) => {
    const value = e.target.value;
    const capitalizedValue = capitalizeWords(value);
    setColor(capitalizedValue);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.color || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        color: validateColor(capitalizedValue),
      }));
    }
  };

  const handleColorBlur = () => {
    setTouched((prev) => ({ ...prev, color: true }));
    setErrors((prev) => ({
      ...prev,
      color: validateColor(color),
    }));
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescription(value);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched
    if (touched.description) {
      setErrors((prev) => ({
        ...prev,
        description: validateDescription(value),
      }));
    }
  };

  const handleDescriptionBlur = () => {
    setTouched((prev) => ({ ...prev, description: true }));
    setErrors((prev) => ({
      ...prev,
      description: validateDescription(description),
    }));
  };

  return (
    <>
      <ToastContainer />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">

          <Header onNavigate={handleHeaderNavigation} />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Add New Model</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Add New Model</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={addModel} noValidate>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-email"
                          >
                            Model <span className="text-danger">*</span>
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-email"
                              className={`form-control ${(touched.model && errors.model) || (submitAttempted && !model.trim()) ? 'is-invalid' : touched.model && !errors.model && model ? 'is-valid' : ''}`}
                              placeholder="Enter Model Name"
                              aria-label="Model Name"
                              aria-describedby="model-error"
                              value={model}
                              onChange={handleModelChange}
                              onBlur={handleModelBlur}
                            />
                          </div>
                          {((touched.model && errors.model) || (submitAttempted && !model.trim())) && (
                            <div className="invalid-feedback d-block" id="model-error">
                              {errors.model || "Model name is required"}
                            </div>
                          )}
                          {touched.model && !errors.model && model && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-phone"
                          >
                            Color <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="basic-default-phone"
                            className={`form-control phone-mask ${(touched.color && errors.color) || (submitAttempted && !color.trim()) ? 'is-invalid' : touched.color && !errors.color && color ? 'is-valid' : ''}`}
                            placeholder="Enter Color name"
                            value={color}
                            onChange={handleColorChange}
                            onBlur={handleColorBlur}
                          />
                          {((touched.color && errors.color) || (submitAttempted && !color.trim())) && (
                            <div className="invalid-feedback d-block">
                              {errors.color || "Color name is required"}
                            </div>
                          )}
                          {touched.color && !errors.color && color && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-message"
                          >
                            Description <small className="text-muted">(Optional)</small>
                          </label>
                          <textarea
                            id="basic-default-message"
                            className={`form-control ${touched.description && errors.description ? 'is-invalid' : touched.description && !errors.description && description ? 'is-valid' : ''}`}
                            placeholder="Enter description (optional)"
                            value={description}
                            rows={3}
                            onChange={handleDescriptionChange}
                            onBlur={handleDescriptionBlur}
                            maxLength={500}
                          />
                          {touched.description && errors.description && (
                            <div className="invalid-feedback d-block">
                              {errors.description}
                            </div>
                          )}
                          {touched.description && !errors.description && description && (
                            <div className="valid-feedback d-block">
                              Looks good!
                            </div>
                          )}
                          <small className="text-muted">
                            {description.length}/500 characters
                          </small>
                        </div>

                        <div className="col-12">
                          <div className="col-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                            >
                              Submit
                            </button>

                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={cancelModel}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
